import { useCallback, useState, useEffect } from 'react';

import { useAuth } from 'reactfire';

const BASE_URL = process.env.REACT_APP_JPD_URL;

const usePublicationsByIds = (ids = []) => {
  const auth = useAuth();
  const [loading, setLoading] = useState(true);
  const [publications, setPublications] = useState([]);

  const body = JSON.stringify({ ids });

  const fetchData = useCallback(async () => {
    setLoading(true);
    const jwt = await auth.currentUser?.getIdToken();

    const response = await fetch(`${BASE_URL}/publications/resolve`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${jwt}`,
      },
      body,
    });
    const data = await response.json();

    setPublications(data.items);
    setLoading(false);
  }, [auth.currentUser, body]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { loading, publications };
};

export default usePublicationsByIds;
